module.exports = __webpack_public_path__ + "img/ic_4.0093d2b8.png";